import * as types from 'src/state/ducks/admin/types';
import { Actions } from 'src/state/ducks/admin/actions';
import { AdminEntity } from 'src/firebase/db/Admins';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';
import { APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';

export interface State {
  isSignIn: boolean;
  isFetching: boolean;
  login_shop_id: string;
  user: AdminEntity;
  validationErrors: ValidationResponse['errors'];
  apiError: APIFailedResponse['error'] | undefined;
  passwordForget: {
    isFetching: boolean;
    isSuccess: boolean;
    apiError: APIFailedResponse['error'] | undefined;
  };
}

const initialState: State = {
  isSignIn: false,
  isFetching: true,
  login_shop_id: '',
  user: {
    role: 0,
    uid: '',
    shop_ids: [],
    shops: [],
  },
  passwordForget: {
    isFetching: false,
    isSuccess: false,
    apiError: undefined,
  },
  validationErrors: {},
  apiError: undefined,
};

const adminReducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case types.IS_LOGIN: {
      return {
        ...state,
        isFetching: false,
        isSignIn: true,
        user: action.payload.data,
      };
    }

    case types.IS_LOGOUT: {
      console.log(action.payload);
      return {
        ...state,
        isFetching: false,
        isSignIn: false,
      };
    }

    case types.LOGIN: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_LOGIN: {
      return {
        ...state,
        isFetching: false,
        isSignIn: true,
        user: action.payload.data,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.SUCCESS_LOGOUT: {
      return initialState;
    }

    case types.FAIL_LOGIN: {
      return {
        ...state,
        isFetching: false,
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.FAIL_LOGOUT: {
      return {
        ...state,
        isFetching: false,
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.CHOOSE_SIGNIN_SHOP: {
      console.log('CHOOSE_SIGNIN_SHOP', action.payload);
      return {
        ...state,
        login_shop_id: action.payload,
      };
    }

    case types.SEND_FORGET_PASSWORD_MAIL: {
      return {
        ...state,
        passwordForget: {
          ...state.passwordForget,
          isFetching: true,
        },
      };
    }

    case types.SUCCESS_FORGET_PASSWORD_MAIL: {
      return {
        ...state,
        passwordForget: {
          isFetching: false,
          isSuccess: true,
          apiError: undefined,
        },
      };
    }

    case types.FAIL_FORGET_PASSWORD_MAIL: {
      console.log(action.payload);
      return {
        ...state,
        passwordForget: {
          isFetching: false,
          isSuccess: false,
          apiError: 'error' in action.payload ? action.payload.error : undefined,
        },
      };
    }

    default:
      return state;
  }
};

export default adminReducer;
